import React from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "../../../../utilities/classNames";

var Column = function Column(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory("GlobalHeaderColumn");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, children);
};

Column.propTypes = {
  /**
   * The contents of the column. If this is a typical navigation menu, you should use `GlobalHeader.NavList` here.
   */
  children: PropTypes.node.isRequired
};
Column.displayName = "GlobalHeader.Column";
export default Column;